import rest from '@modules/rest'

/**
 * Creates an onInput callback for cep fields which autofill address data.
 *
 * @param {Object} addressMap- Object containing keys of returned cep service
 * to reference on formData fields
 * @returns {Function} - The onInput function which will make the autofill
 */

export const cepSearch = async cep => {
  if ((cep || '').length !== 9) return

  const formattedCep = cep.replace('-', '')
  const data = await rest.get(`/common/cep-address/${formattedCep}`)

  return data
}

export default (addressMap) => async function cepFillListener (formData, rawCep) {
  if ((rawCep || '').length !== 9) return

  let cepData

  try {
    cepData = await cepSearch(rawCep)
  } catch (err) {
    return
  }

  if (!cepData?.success) return

  formData[addressMap.neighborhood || 'neighborhood'] = cepData.neighborhood
  formData[addressMap.street || 'street'] = cepData.street
  formData[addressMap.state || 'state'] = cepData.state.id
  formData[addressMap.city || 'city'] = cepData.city.id
  formData.number = ''
  formData.complement = ''
}
